exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#app{font-family:Avenir,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-align:center;color:#515151;margin-top:0;display:flex;flex-direction:column;min-height:99vh;box-sizing:border-box}.fade-enter-active,.fade-leave-active{transition:all .2s ease-in}.fade-enter,.fade-leave-to{opacity:0}h1,h2{font-weight:700}ul{list-style-type:none;padding:0}li{display:inline-block;margin:0 10px}a{color:#f05967;text-decoration:none;transition:all .1s}a:hover{color:#f07883}nav>a{color:#d1d1d1;font-size:1.5rem;padding:0}nav>a:hover{color:#a9b6c5}header{padding:1rem}footer{padding:.5rem;color:#9f9f9f}.sticky-main{flex:1 0 80%}.blog-title{font-size:2.5rem;margin:2rem 0 .5rem;font-weight:100}.blog-title a{color:#515151}@media (max-width:500px){.blog-title{font-size:2rem;margin-top:1.5rem;margin-bottom:.25rem}nav>a{font-size:1.5rem}ul{margin:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4866abf7","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 255
// module chunks = 0